import { ICellRenderer } from 'ag-grid-community';
import { ActionItem } from '../ambient-template-grid/interfaces/gridInterfaces';
import { getIconFromName } from '../../data-display/icons/iconUtils';

export default class ActionsRenderer implements ICellRenderer {
  private eGui: HTMLElement;
  private actionList: ActionItem[] = [];

  public init(params: any): void {
    this.eGui = document.createElement('div');
    this.eGui.style.cssText = `display: flex;
      width: 100%;
      gap: 4px;
      justify-content: center;
    `;

    if (params?.hideActions && params?.hideActions(params?.node)) {
      return;
    }

    this.actionList = params?.actionList;
    this.actionList?.forEach(action => {
      const disabledAction = action?.checkDisabled ? action?.checkDisabled(params?.node) : action?.disabled ?? false;
      const actionTitle = action?.getTitle ? action?.getTitle(params?.node) : action?.title;
      const actionButton = document.createElement('stencil-icon-button');

      actionButton.buttonId = action?.id.toString();
      actionButton.icon = getIconFromName(action?.iconName);
      actionButton.tooltip = actionTitle;
      actionButton.disabled = disabledAction;
      actionButton.onClick = e => {
        action?.handleOnClick(e, params?.node);
      };

      this.eGui.appendChild(actionButton);
    });
  }

  public getGui(): HTMLElement {
    return this.eGui;
  }

  public refresh(): boolean {
    return true;
  }
}
